import { apiFetch } from './api';
import React, { useEffect, useState, useCallback } from 'react';

function ContattiPrenotazione({ onIniziativaSelect }) {
  const [iniziative, setIniziative] = useState([]);
  const [filteredIniziative, setFilteredIniziative] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedIdManager, setSelectedIdManager] = useState(null);
  
  // 🔧 STATI PER ORDINAMENTO - STANDARDIZZATI
  const [sortField, setSortField] = useState('nome'); // Default: Nome ASC
  const [sortDirection, setSortDirection] = useState('asc');
  
  // 🔧 STATI PER FILTRI
  const [searchNome, setSearchNome] = useState('');
  const [searchTitolo, setSearchTitolo] = useState('');
  const [searchLuogo, setSearchLuogo] = useState('');
  
  // 🔧 STATO PROCESSING PER LOADER
  const [processingSelection, setProcessingSelection] = useState(false);

  // 🔧 CARICAMENTO DATI
  useEffect(() => {
    async function fetchIniziative() {
      setLoading(true);
      try {
        console.log('🔄 Caricamento iniziative in corso...');
        const response = await apiFetch('/api/Iniziative/lista_incorso');
        if (response.ok) {
          const data = await response.json();
          const iniziativeArray = Array.isArray(data) ? data : [];
          setIniziative(iniziativeArray);
          setFilteredIniziative(iniziativeArray);
          console.log(`✅ Caricate ${iniziativeArray.length} iniziative`);
        } else {
          setIniziative([]);
          setFilteredIniziative([]);
        }
      } catch (err) {
        console.error('❌ Errore caricamento iniziative:', err);
        setIniziative([]);
        setFilteredIniziative([]);
      }
      setLoading(false);
    }
    fetchIniziative();
  }, []);

  // 🔧 FUNZIONE ORDINAMENTO STANDARDIZZATA - CON LOADER IMMEDIATO
  const handleSort = useCallback((field) => {
    // 🔧 ATTIVA LOADER IMMEDIATAMENTE AL CLICK
    setProcessingSelection(true);
    
    setSortField(prevField => {
      setSortDirection(prevDirection => {
        if (prevField === field) {
          return prevDirection === 'asc' ? 'desc' : 'asc';
        } else {
          return 'asc';
        }
      });
      return field;
    });
  }, []);

  // 🔧 FUNZIONE ICONE ORDINAMENTO - IDENTICA A Contatti.js
  const getSortIcon = (field) => {
    if (sortField !== field) {
      return <i className="fas fa-sort text-muted ms-1"></i>;
    }
    return sortDirection === 'asc' ? 
      <i className="fas fa-sort-up text-primary ms-1"></i> : 
      <i className="fas fa-sort-down text-primary ms-1"></i>;
  };

  // 🔧 APPLICA FILTRI E ORDINAMENTO - CORRETTO SENZA LOOP
  const applyFilters = useCallback(() => {
    setProcessingSelection(true);
    
    setTimeout(() => {
      let filtered = [...iniziative];
      
      // FILTRI
      if (searchNome.trim()) {
        filtered = filtered.filter(i => 
          i.nome && i.nome.toLowerCase().includes(searchNome.toLowerCase())
        );
      }
      
      if (searchTitolo.trim()) {
        filtered = filtered.filter(i => 
          i.titolo && i.titolo.toLowerCase().includes(searchTitolo.toLowerCase())
        );
      }
      
      if (searchLuogo.trim()) {
        filtered = filtered.filter(i => 
          i.luogo && i.luogo.toLowerCase().includes(searchLuogo.toLowerCase())
        );
      }
      
      // 🔧 ORDINAMENTO STANDARDIZZATO
      if (sortField) {
        filtered.sort((a, b) => {
          let valueA = a[sortField];
          let valueB = b[sortField];
          
          // Gestione valori nulli
          if (valueA == null) valueA = '';
          if (valueB == null) valueB = '';
          
          // Conversione per ordinamento alfabetico
          valueA = String(valueA).toLowerCase();
          valueB = String(valueB).toLowerCase();
          
          // Confronto finale
          if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1;
          if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1;
          return 0;
        });
      }
      
      setFilteredIniziative(filtered);
      setProcessingSelection(false);
    }, 0);
  }, [iniziative, searchNome, searchTitolo, searchLuogo, sortField, sortDirection]); // 🔧 RIMOSSO processingSelection dalle dipendenze

  // Applica filtri quando cambiano
  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  // 🔧 GESTIONE SELEZIONE INIZIATIVA
  const handleIniziativaSelect = useCallback((idManager, iniziativa) => {
    setSelectedIdManager(idManager);
    if (onIniziativaSelect) {
      onIniziativaSelect(idManager, iniziativa);
    }
  }, [onIniziativaSelect]);

  return (
    <>
      <div className="card mb-4">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0 text-primary">
              <i className="fas fa-calendar-alt me-2"></i> Iniziative in corso
            </h5>
            <div className="d-flex align-items-center">
              {selectedIdManager && (
                <span className="badge bg-success me-2">
                  <i className="fas fa-check me-1"></i>
                  Iniziativa selezionata
                </span>
              )}
              <span className="badge bg-info me-2">
                <i className="fas fa-list me-1"></i>
                {filteredIniziative.length} elementi
              </span>
              <span className="badge bg-primary">
                <i className="fas fa-calendar me-1"></i>
                Totale: {iniziative.length}
              </span>
            </div>
          </div>
        </div>
        
        <div className="card-body">
          {/* 🔧 FILTRI DI RICERCA - AGGIUNTI */}
          <div className="row mb-3">
            <div className="col-md-4">
              <label className="form-label fw-bold text-start w-100">
                <i className="fas fa-tag me-1 text-muted"></i> Nome:
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Filtra per nome..."
                value={searchNome}
                onChange={(e) => setSearchNome(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-bold text-start w-100">
                <i className="fas fa-heading me-1 text-muted"></i> Titolo:
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Filtra per titolo..."
                value={searchTitolo}
                onChange={(e) => setSearchTitolo(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-bold text-start w-100">
                <i className="fas fa-map-marker-alt me-1 text-muted"></i> Luogo:
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Filtra per luogo..."
                value={searchLuogo}
                onChange={(e) => setSearchLuogo(e.target.value)}
              />
            </div>
          </div>

          {/* 🔧 TABELLA CON ORDINAMENTO E LOADER */}
          <div className="table-responsive position-relative" style={{ maxHeight: 400, overflowY: 'auto' }}>
            {(loading || processingSelection) && (
              <div className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-white bg-opacity-75" style={{zIndex:10}}>
                <i className="fas fa-spinner fa-spin fa-3x text-primary mb-3"></i>
                <div className="fw-bold fs-5">
                  {loading ? 'Caricamento iniziative...' : 'Aggiornamento ordinamento...'}
                </div>
              </div>
            )}
            
            <table className="table table-striped table-hover mb-0">
              <thead className="table-dark sticky-top">
                <tr>
                  <th style={{cursor:'pointer'}} onClick={() => handleSort('nome')}>
                    Nome {getSortIcon('nome')}
                  </th>
                  <th style={{cursor:'pointer'}} onClick={() => handleSort('titolo')}>
                    Titolo {getSortIcon('titolo')}
                  </th>
                  <th style={{cursor:'pointer'}} onClick={() => handleSort('messaggio')}>
                    Messaggio {getSortIcon('messaggio')}
                  </th>
                  <th style={{cursor:'pointer'}} onClick={() => handleSort('luogo')}>
                    Luogo {getSortIcon('luogo')}
                  </th>
                  <th>Logo</th>
                </tr>
              </thead>
              <tbody>
                {filteredIniziative.length > 0 ? filteredIniziative.map(i => (
                  <tr 
                    key={i.idManager} 
                    style={{cursor:'pointer'}} 
                    onClick={() => handleIniziativaSelect(i.idManager, i)}
                    className={selectedIdManager === i.idManager ? 'table-primary' : ''}
                  >
                    <td>
                      <div className="d-flex align-items-center">
                        {selectedIdManager === i.idManager && (
                          <i className="fas fa-check-circle text-success me-2"></i>
                        )}
                        <span className="fw-bold">{i.nome}</span>
                      </div>
                    </td>
                    <td>
                      <div className="text-truncate" style={{maxWidth: '200px'}} title={i.titolo}>
                        {i.titolo}
                      </div>
                    </td>
                    <td>
                      <div className="text-truncate" style={{maxWidth: '250px'}} title={i.messaggio}>
                        <small className="text-muted">{i.messaggio}</small>
                      </div>
                    </td>
                    <td>
                      <span className="badge bg-info">
                        <i className="fas fa-map-marker-alt me-1"></i>
                        {i.luogo}
                      </span>
                    </td>
                    <td>
                      {i.logo ? (
                        <img 
                          src={i.logo} 
                          alt="logo iniziativa" 
                          style={{maxHeight:'32px', maxWidth:'60px'}}
                          className="rounded"
                        />
                      ) : (
                        <span className="text-muted">
                          <i className="fas fa-image"></i>
                        </span>
                      )}
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={5} className="text-center text-muted py-4">
                      <i className="fas fa-calendar-times fa-2x mb-2"></i><br />
                      {loading ? 'Caricamento in corso...' : 'Nessuna iniziativa trovata'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* 🔧 INFO SELEZIONE - CORRETTA */}
          {filteredIniziative.length > 0 && (
            <div className="d-flex justify-content-between align-items-center mt-3">
              <small className="text-muted">
                <i className="fas fa-info-circle me-1"></i>
                Visualizzate {filteredIniziative.length} di {iniziative.length} iniziative
              </small>
              {selectedIdManager && (
                <small className="text-success">
                  <i className="fas fa-check-circle me-1"></i>
                  Iniziativa selezionata - ID: {selectedIdManager}
                </small>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ContattiPrenotazione;